/**
 * This will log to the console when in development env, or when executing on the server.
 * @param {string=log} level - log or error.
 * @param {...*} messages - varargs, same as console.log or console.error.
 */
var logInner = function logInner() {
  var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'log';

  if (process.env === 'development' || typeof window === 'undefined') {
    var _console;

    for (var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      messages[_key - 1] = arguments[_key];
    }

    (_console = console)[level].apply(_console, messages); // eslint-disable-line no-console

  }
};

export default {
  error: function error() {
    for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      messages[_key2] = arguments[_key2];
    }

    return logInner.apply(void 0, ['error'].concat(messages));
  },
  log: function log() {
    for (var _len3 = arguments.length, messages = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      messages[_key3] = arguments[_key3];
    }

    return logInner.apply(void 0, ['log'].concat(messages));
  }
};